var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.25V2.25H8.25V8.25H2.25ZM2.25 15.75V9.75H8.25V15.75H2.25ZM9.75 8.25V2.25H15.75V8.25H9.75ZM9.75 15.75V9.75H15.75V15.75H9.75ZM3.75 6.75H6.75V3.75H3.75V6.75ZM11.25 6.75H14.25V3.75H11.25V6.75ZM11.25 14.25H14.25V11.25H11.25V14.25ZM3.75 14.25H6.75V11.25H3.75V14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGridView);
export default __webpack_public_path__ + "static/media/icon-grid-view.7b9bc3830a8a4e9029e6a0b9b3ece9d6.svg";
export { ForwardRef as ReactComponent };